import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "@/pages/variant-product/Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import Modal from "./Model"
import { useState } from "react"
import { CrudProvider, useCrudContext } from "@/context/crudContext"

export default function ProductVariant() {
  return (
    <>
      <div className="breadcrumb-card">
        <h5>Product Variants</h5>
      </div>

      <CrudProvider>
        <ProductVariantTable />
      </CrudProvider>
    </>
  )
}

function ProductVariantTable() {
  const { openDialog } = useCrudContext()

  return (
    <>
      <CustomTable
        label="Product Variants"
        columns={columns}
        apiPath="product-variant"
      />

      {openDialog ? <Modal /> : null}
    </>
  )
}
